import { useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom"

import { useLazyQuery } from "@apollo/client";

import { GET_USER_DEVICE_DATA } from "../../app/graphql/queries";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import { ErrorManagementContext } from "../../utils/errorManagement/ErrorManagementProvider";
import LoadingUpAnimation from "../LoadingUpAnimation";
import deviceRegistrationCall from "./deviceRegistration.thunk";

interface RouteParams {
  deviceId: string;
}

const DeviceRegistration = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()

  const { deviceId } = useParams<RouteParams>();

  const { cookClubLog } = useContext(ErrorManagementContext);

  const [fetchUserConnectedDevice] = useLazyQuery(GET_USER_DEVICE_DATA, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only'
  })

  // user details should come from useauth
  const userHasuraID = useAppSelector((state) => state.auth.userHasuraID) // can use upAuth context to get user details
  const localMobJwt = useAppSelector((state) => state.main.userAccessToken) // can use upAuth context

  useEffect(() => {

    if (userHasuraID && localMobJwt && deviceId) {
      dispatch(deviceRegistrationCall({ history, userHID: userHasuraID, deviceId, mjwt: localMobJwt, cookClubLog, fetchUserConnectedDevice })) // ensure to trigger only once
    }

  }, [userHasuraID, localMobJwt, deviceId])
  return <LoadingUpAnimation />
}

export default DeviceRegistration